export {}; // TODO: Remove semicolon from previous line, uncomment next line, and provide union of props to pick from CopilotMessageProps.
// & Required<Pick<CopilotMessageProps, 'propName'>>
//# sourceMappingURL=CopilotMessage.types.js.map